var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDismiss16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.519 3.187a.5.5 0 1 0-.707-.708L7.999 7.293 3.186 2.479a.5.5 0 1 0-.708.708L7.292 8l-4.814 4.813a.5.5 0 0 0 .708.707l4.813-4.813 4.813 4.813a.5.5 0 1 0 .707-.707L8.706 8l4.813-4.813Z",
  fill: "#8B97A7"
})));
export default SvgIcDismiss16X16;